import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FormControlLabel, Grid, FormGroup, Checkbox } from "@mui/material";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { useSelections } from "../../../context/Selections";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function PeformanceTimeDesktop({ app, config }) {
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [moreThanOneValue, setMoreThanOneValue] = useState([]);
  const [getSelectedValue, setGetSelectedValue] = useState([]);

  useEffect(() => {
    if (app) {
      getValuesInputChecks();
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Faixa_Pedagio")
        : null;
      distributors?.qSelected &&
        setGetSelectedValue(distributors.qSelected?.split(", "));
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const getValuesInputChecks = () => {
    const myField = app?.field("Faixa_Pedagio").getData();
    setMoreThanOneValue(myField.rows);
  };

  const clearFilter = () => {
    app.field("Faixa_Pedagio").clear();
    setGetSelectedValue([]);
  };

  const handleChange = (event) => {
    if (event.target.value) {
      const index = moreThanOneValue.find(
        (elemento) => elemento.qText === event.target.value
      );

      if (getSelectedValue.includes(event.target.value)) {
        app.field("Faixa_Pedagio").select([index.qElemNumber], true, true);
      } else {
        app.field("Faixa_Pedagio").select([index.qElemNumber], true, true);
      }
    }
  };

  return (
    <>
      <h2 className="container-title">Visão: </h2>
      <FormGroup
        sx={{ marginLeft: "20px", marginBottom: "16px" }}
        className="container-check"
      >
        <FormControlLabel
          onClick={clearFilter}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value={"Total de Lojas"}
              checked={
                getSelectedValue.length > 5 || getSelectedValue.length === 0
              }
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="Total de Lojas"
        />

        <FormControlLabel
          onChange={(e) => handleChange(e)}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value="< R$ 6.000"
              checked={getSelectedValue.includes("< R$ 6.000")}
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="< R$ 6.000"
        />

        <FormControlLabel
          onChange={(e) => handleChange(e)}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value="> R$ 24.000"
              checked={getSelectedValue.includes("> R$ 24.000")}
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="> R$ 24.000"
        />

        <FormControlLabel
          onChange={(e) => handleChange(e)}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value="R$ 9.000"
              checked={getSelectedValue.includes("R$ 9.000")}
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="R$ 9.000"
        />

        <FormControlLabel
          onChange={(e) => handleChange(e)}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value="R$ 12.000"
              checked={getSelectedValue.includes("R$ 12.000")}
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="R$ 12.000"
        />

        <FormControlLabel
          onChange={(e) => handleChange(e)}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value="R$ 18.000"
              checked={getSelectedValue.includes("R$ 18.000")}
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="R$ 18.000"
        />

        <FormControlLabel
          onChange={(e) => handleChange(e)}
          sx={{
            color: "#212121",
            fontSize: "14px",
            lineHeight: "17px",
          }}
          control={
            <Checkbox
              value="R$ 24.000"
              checked={getSelectedValue.includes("R$ 24.000")}
              sx={{
                color: "#FD66B2",
                "&.Mui-checked": {
                  color: "#FD66B2",
                },
                borderRadius: "50%",
              }}
              icon={<CircleOutlinedIcon />}
              checkedIcon={<RadioButtonCheckedIcon />}
              size="small"
            />
          }
          label="R$ 24.000"
        />
      </FormGroup>

      <LayoutCardsWrapper>
        <Grid container rowGap={2}>
          <LayoutCardWrapper
            style={{
              paddingLeft: "10px",
              marginBottom: "16px",
              height: "409px",
            }}
          >
            <Card
              app={app}
              header={{
                hardTitle: "Evolução Anual",
              }}
              exportTable
              exportContainer
              exportTableId="spNRe"
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <ul className="container-legendas">
                <li className="item-1">% Ljs. pedágio</li>
                <li className="item-2">% MSL Ating.</li>
                <li className="item-3">% PE Exec.</li>
                <li className="item-4">% PDV c/ Inov.</li>
                <li className="item-5">Cres VS LY</li>
                <li className="item-6">% Aprov. da camp.</li>
                <li className="item-7">Cresc. ST VS LY</li>
              </ul>

              <NativeObject app={app} key="spNRe" reference={{ id: "spNRe" }} />
            </Card>
          </LayoutCardWrapper>
        </Grid>

        <Grid item width={"100%"}>
          <LayoutCardWrapper
            style={{
              paddingLeft: "10px",
              marginBottom: "16px",
              height: "390px",
            }}
            className={"container-table"}
          >
            <Card
              app={app}
              header={{
                hardTitle: "Tabela - Evolução Anual",
              }}
              exportTable
              exportContainer
              exportTableId="pnfjYy"
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <NativeObject
                app={app}
                key="pnfjYy"
                reference={{ id: "pnfjYy" }}
              />
            </Card>
          </LayoutCardWrapper>
        </Grid>
      </LayoutCardsWrapper>
    </>
  );
}

PeformanceTimeDesktop.defaultProps = {
  app: null,
  config: {},
};

PeformanceTimeDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PeformanceTimeDesktop;
